import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/diarias/listar/form_edit'
import Head from '../../../../components/head'


function EditarDiariasScreen () {
    return (
        <Fragment>
            <Head titulo="Editando diária concedida aos servidores do Município de Macuco" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarDiariasScreen;